import { UpcomingInvoiceParams } from './types';

export const keys = {
  subscription: ['subscription'] as const,
  upcoming: (params: Partial<UpcomingInvoiceParams>) =>
    [...keys.subscription, 'upcoming', { params }] as const,
  detail: () => [...keys.subscription, 'detail'],
} as const;
